import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils'; // Pfad ggf. anpassen

/* Put all uiSchema options here, in the template they go under ui:options: */
export const InfoAlertUiOptionsSchema = z.object({
  text: z
    .string()
    .describe('The text to display inside the blue info alert box.'),
});

// Transforms the Zod schema to a TypeScript type
export type InfoAlertUiOptions = z.infer<typeof InfoAlertUiOptionsSchema>;

/* The field schema for the InfoAlert field extension */
// Wir nutzen z.string().optional(), da dieses Feld keine echten Daten speichern muss
export const InfoAlertFieldSchema = makeFieldSchemaFromZod(
  z.string().optional().describe('Dummy field for displaying an info alert'),
  InfoAlertUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type InfoAlertFieldProps = typeof InfoAlertFieldSchema.type;

/* The final schema used for the field extension */
export const InfoAlertSchema = InfoAlertFieldSchema.schema;
